<template>
  <span class="tw-inline-flex tw-items-center" :class="buttons ? 'tw-gap-2' : 'tw-gap-3'">
    <router-link
      v-if="pollingTo && canPoll"
      :to="pollingTo"
      target="_blank"
      :class="linkClass"
      title="Polling-pagina van dit adres in het ERP"
    >
      <ChartBarIcon class="tw-h-4 tw-w-4" /> Polling
    </router-link>
    <span
      v-else
      :class="disabledClass"
      :title="pollingTo ? POLLING_DISABLED_TITLE : 'Geen geldig adres (postcode + huisnummer)'"
    >
      <ChartBarIcon class="tw-h-4 tw-w-4" /> Polling
    </span>

    <a
      v-if="mijnNormHref"
      :href="mijnNormHref"
      target="_blank"
      rel="noopener"
      :class="linkClass"
      :title="MIJN_NORM_TITLE"
    >
      <ExternalLinkIcon class="tw-h-4 tw-w-4" /> Mijn Norm
    </a>
    <span
      v-else
      :class="disabledClass"
      title="Geen geldig adres (postcode + huisnummer)"
    >
      <ExternalLinkIcon class="tw-h-4 tw-w-4" /> Mijn Norm
    </span>
  </span>
</template>

<script setup>
// The monitoring links of an address: the ERP polling page and the tenant's view on mijn.norm.eu.
// Pass the address as postalCode + houseNumber or as a tickets locationId (1234AB12-A); a
// serialNumber, when known, opens polling on that meter directly.
import { computed } from 'vue'
import { ChartBarIcon, ExternalLinkIcon } from '@vue-hero-icons/outline'
import {
  toLocationId,
  fromLocationId,
  pollingRoute,
  canViewPolling,
  mijnNormUrl,
  MIJN_NORM_TITLE,
  POLLING_DISABLED_TITLE,
} from '@/util/meterLinks'

const props = defineProps({
  postalCode: { type: String, default: null },
  houseNumber: { type: [String, Number], default: null },
  locationId: { type: String, default: null },
  serialNumber: { type: String, default: null },
  // as Bulma buttons (headers) instead of text links
  buttons: { type: Boolean, default: false },
})

const linkClass = computed(() =>
  props.buttons
    ? 'button is-info is-outlined tw-gap-1'
    : 'tw-inline-flex tw-items-center tw-gap-1 tw-text-green-600 hover:tw-underline'
)
const disabledClass = computed(() =>
  props.buttons
    ? 'button tw-gap-1 tw-opacity-50 tw-cursor-not-allowed'
    : 'tw-inline-flex tw-items-center tw-gap-1 tw-text-gray-400 tw-cursor-not-allowed'
)

const address = computed(() =>
  props.locationId
    ? fromLocationId(props.locationId)
    : { postalCode: props.postalCode, houseNumber: props.houseNumber }
)

const pollingTo = computed(() =>
  pollingRoute({
    serialNumber: props.serialNumber,
    locationId: toLocationId(address.value?.postalCode, address.value?.houseNumber),
  })
)
const canPoll = canViewPolling()
const mijnNormHref = computed(() => mijnNormUrl(address.value?.postalCode, address.value?.houseNumber))
</script>
